class XToast extends HTMLElement {
    constructor() {
        super();

        this._queue = [];
        this._visible = false;
        this._container = document.createElement('div');
        this._container.className = 'toast-container';
        this.appendChild(this._container);
    }

    connectedCallback() {
        this._onGlobal = (e) => {
            const d = e.detail || {};
            const message = d.message ?? d.msg ?? d.text;
            const type = d.type ?? 'info';
            const duration = typeof d.duration === 'number' ? d.duration : undefined;
            if (message) this.show(message, { type, duration });
        };
        window.addEventListener('toast', this._onGlobal);

        if (this.hasAttribute('message')) {
            this.show(this.getAttribute('message'), { type: this.getAttribute('type') || 'info' });
            this.removeAttribute('message');
        }
    }

    disconnectedCallback() {
        window.removeEventListener('toast', this._onGlobal);
    }

    static get observedAttributes() {
        return ['message', 'type', 'duration'];
    }

    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'message' && newVal) {
            const type = this.getAttribute('type') || 'info';
            const duration = this.hasAttribute('duration') ? parseInt(this.getAttribute('duration'), 10) : undefined;
            this.show(newVal, { type, duration });
            this.removeAttribute('message');
        }
    }

    show(message, opts = {}) {
        const type = opts.type || 'info';
        const duration = Number.isFinite(opts.duration) ? opts.duration : 4000;

        this._queue.push({ message, type, duration });
        if (!this._visible) this._processQueue();
    }

    _processQueue() {
        if (this._queue.length === 0) {
            this._visible = false;
            return;
        }

        this._visible = true;
        const item = this._queue.shift();
        const toast = document.createElement('div');
        toast.className = `toast ${item.type}`;
        toast.innerHTML = `
            <div class="msg">${this._escapeHtml(String(item.message))}</div>
            <button class="close-btn" aria-label="close">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    class="icon icon-close"
                    fill="none"
                    viewBox="0 0 18 17"
                >
                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </svg>
            </button>
            `;
        
        const closeBtn = toast.querySelector('.close-btn');
        const remove = () => {
            toast.classList.remove('show');
            toast.addEventListener('transitionend', () => {
                if (toast.parentNode) toast.parentNode.removeChild(toast);
            }, { once: true });
            setTimeout(() => this._processQueue(), 120);
        };

        closeBtn.addEventListener('click', () => {
            clearTimeout(timer);
            remove();
        });

        this._container.appendChild(toast);
        
        void toast.offsetWidth;
        toast.classList.add('show');

        const timer = setTimeout(() => {
            remove();
        }, item.duration);
    }

    _escapeHtml(str) {
        return str.replace(/[&<>"'`=\/]/g, s => {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#x60;',
                '=': '&#x3D;'
            };
            return map[s];
        });
    }
}
customElements.define('x-toast', XToast);

window.addEventListener('DOMContentLoaded', () => {
    window.toast = document.querySelector('x-toast');
});